import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import {
    FertilizerProductId,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductTotal, makeSelectProductUnitType } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
    perUnitType: FertilizerProductPerUnitType;
}

type Props = OwnProps;

export default function ProductTotalTableCell(
    props: Props
): React.ReactElement {
    const productUnitType = useSelector((state: AppState) =>
        makeSelectProductUnitType()(state, props)
    );
    const productTotal = useSelector((state: AppState) =>
        makeSelectProductTotal()(state, props)
    );

    return (
        <TableCell>
            {productTotal} {productUnitType}
        </TableCell>
    );
}
